"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var Preact = __importStar(require("preact"));
var PC = __importStar(require("./M_ProductCard"));
var Component = function (p) { return (Preact.h(Box_1.default, { sx: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: '12px',
    } }, p.products.map(function (pr) {
    var _a;
    return (Preact.h(PC.Component, { imageUrl: pr.imageUrl, title: pr.title, price: pr.price, lastPrice: pr.lastPrice, leadTime: pr.leadTime, onAddClick: function () { return p.onProductAddClick(pr.id); }, disabled: p.loading, loading: ((_a = p.loadingProductId) !== null && _a !== void 0 ? _a : '') === pr.id }));
}))); };
exports.Component = Component;
